import React from 'react'
import "./Social.css"

function Social() {
  return (
    <div className='project-section'>
         <div className="rightNav" data-aos="fade-in">
             <a  rel="noreferrer" href="https://www.linkedin.com/in/khaled-mohamed-398619182/" target="_blank"  >  <img alt="socialmediaIcon" src="https://img.icons8.com/color/60/000000/linkedin.png"/>     </a>  
             <a  rel="noreferrer" href="https://www.facebook.com/khaled.muhammad.35574" target="_blank" > <img alt="socialmediaIcon" src="https://img.icons8.com/color/60/000000/facebook-new.png"/></a>  
             <a rel="noreferrer" href="https://github.com/khalledmuhammad" target="_blank" > <img alt="socialmediaIcon" src="https://img.icons8.com/ios-glyphs/60/000000/github.png"/>    </a>   
             <a rel="noreferrer" href="https://www.instagram.com/khaaledmohamad/" target="_blank" > <img alt="socialmediaIcon" src="https://img.icons8.com/fluency/60/000000/instagram-new.png"/></a>  
             <a rel="noreferrer" href="https://twitter.com/KhaledM50926178" target="_blank" > <img alt="socialmediaIcon" src="https://img.icons8.com/color/60/000000/twitter--v1.png"/></a>  
               </div>
    </div>
  )
}

export default Social